// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"51":"mock-data","426":"mock"}[chunkId] + "." + {"51":"fb01008771ab2cb1031c","426":"eb983b61f012d391b6ee"}[chunkId] + ".js";
};